import React from 'react';
import { Stack } from '@/components/ui/layout';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { FileText, Video, CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

function ActionButtons({ onViewChange, currentView, resumeCompleted, videoCompleted }) {
  const buttons = [
    { 
      icon: FileText, 
      text: "Create Resume", 
      view: "resume",
      completed: resumeCompleted
    },
    { 
      icon: Video, 
      text: "Create Video", 
      view: "video",
      completed: videoCompleted
    }
  ];

  return (
    <Stack spacing="sm" className="w-full max-w-[200px]">
      {buttons.map((button, index) => {
        const Icon = button.icon;
        const isActive = currentView === button.view;
        const isCompleted = button.completed;
        
        return (
          <Button
            key={index}
            variant={isActive ? "default" : "outline"}
            className={cn(
              "w-full justify-start gap-3 h-auto py-3 px-4",
              "transition-all duration-200",
              isCompleted && !isActive && "border-success/50 bg-success/5 hover:bg-success/10",
              isActive && "shadow-sm"
            )}
            onClick={() => onViewChange(button.view)}
          >
            <Icon className={cn(
              "w-5 h-5 shrink-0",
              isActive ? "text-primary-foreground" : "text-foreground",
              isCompleted && !isActive && "text-success"
            )} />
            <span className="flex-1 text-left font-medium">{button.text}</span>
            {isCompleted && (
              <Badge 
                variant="success" 
                className={cn(
                  "ml-auto shrink-0",
                  isActive && "bg-success/20 text-success border-success/40"
                )}
              >
                <CheckCircle2 className="w-3 h-3 mr-1" />
                Done
              </Badge>
            )}
          </Button>
        );
      })}
    </Stack>
  );
}

export default ActionButtons;
